import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import Checkbox from '@material-ui/core/Checkbox';
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function DashboardConfigurationDrawer(props) {
    const classes = useStyles();

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>Dashboard configuration</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.body}>
            <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.dashboard.currentOrderBoard}
                        onChange={() => props.actions.toggleCurrentOrderBoard(!props.dashboard.currentOrderBoard)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>Current order</div>
                </div>
                <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.dashboard.nextOrderBoard}
                        onChange={() => props.actions.toggleNextOrderBoard(!props.dashboard.nextOrderBoard)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>Next order</div>
                </div>
                <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.dashboard.statusBoard}
                        onChange={() => props.actions.toggleStatusBoard(!props.dashboard.statusBoard)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>Machine status</div>
                </div>
                <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.dashboard.changeStatusBoard}
                        onChange={() => props.actions.toggleChangeStatusBoard(!props.dashboard.changeStatusBoard)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>Change machine status</div>
                </div>
                <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        onChange={() => props.actions.toggleShiftPerformanceBoard(!props.dashboard.shiftPerformanceBoard)}
                        checked={props.dashboard.shiftPerformanceBoard}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>Shift performance</div>
                </div>
                <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        onChange={() => props.actions.toggleOEEBoard(!props.dashboard.OEEBoard)}
                        checked={props.dashboard.OEEBoard}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>OEE</div>
                </div>
                <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.dashboard.progressionBoard}
                        onChange={() => props.actions.toggleProgressionBoard(!props.dashboard.progressionBoard)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>Progression</div>
                </div>
                <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.dashboard.messagesBoard}
                        onChange={() => props.actions.toggleMessagesBoard(!props.dashboard.messagesBoard)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>Messages</div>
                </div>
                <div className={classes.board}>
                    <Checkbox
                        className={classes.checkBox}
                        disableRipple
                        color="default"
                        checked={props.dashboard.speedBoard}
                        onChange={() => props.actions.toggleSpeedBoard(!props.dashboard.speedBoard)}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        inputProps={{ 'aria-label': 'decorative checkbox' }}
                    // {...props}
                    />
                    <div className={classes.boardName}>Throughput</div>
                </div>

            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "5px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    drawerOpen: {
        width: "20%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        display: "inline-block",
        verticalAlign: "top"
    },
    title: {
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px",
        display: "inline-block"
    },

    header: {
        width: "100%",
        height: "auto",
        marginBottom: "20px"
    },
    checkBox: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        float: "left"
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
    },
    boardName: {
        float: "left",
        paddingTop: "8px",
        marginLeft: "5px",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
    },
    board: {
        width: "100%",
        height: "40px"
    }



}));